import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import MasterViewController from "../../redux/actions/masterApiActions";
import { useDispatch, useSelector } from "react-redux";
import Editor from "react-simple-wysiwyg";
import { FaPlus, FaTrash } from "react-icons/fa";
import {
  Grid,
  Typography,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  TextField, MenuItem, Autocomplete
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FadeLoader } from "react-spinners";

const applicabilityOptions = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Half-Yearly", value: "half_yearly" },
  { label: "Annually", value: "annually" },
  { label: "On Demand", value: "on_demand" },
];

const challanTypeOptions = [
  { label: "Percentage", value: "percentage" },
  { label: "Fixed Amount", value: "fixed" },
  { label: "Salary Range Based", value: "salary_range" },
  { label: "Custom Logic", value: "custom" },
];

const contributionTypeOptions = [
  { label: "Percentage", value: "percentage" },
  { label: "Fixed", value: "fixed" },
  { label: "Salary Range", value: "salary_range" },
];


function ChallanFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addChallanMaster, updateChallan } = MasterViewController();
  const isEdit = Boolean(initialData?.id); 
  const {isLoding } = useSelector((state) => state.master);

  const [initialValues, setInitialValues] = useState({
    name: "",
    amount: "",
    percentage: "",
    description: "",
    salary_range_amount: {},
    challan_type: "",
    applicability: "monthly",
    applicable_salary_component: "",
    applicable_months: [],
  });

  const [salaryRangeEntries, setSalaryRangeEntries] = useState([["", ""]]);


  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        name: initialData.name || "",
        amount: initialData.amount || "",
        percentage: initialData.percentage || "",
        description: initialData.description || "",
        salary_range_amount: initialData.salary_range_amount || {},
        challan_type: initialData.challan_type || "",
        applicability: initialData.applicability || "monthly",
        applicable_salary_component: initialData.applicable_salary_component || "",
        applicable_months: initialData.applicable_months || [],
        employee_contribution: initialData.employee_contribution || {},
        employer_contribution: initialData.employer_contribution || {}
      });

      const entries = Object.entries(initialData.salary_range_amount || {});
      setSalaryRangeEntries(entries);
    } else if (show && !initialData) {
      setInitialValues({
        name: "",
        amount: "",
        percentage: "",
        description: "",
        salary_range_amount: {},
        challan_type: "",
        applicability: "monthly",
        applicable_salary_component: "",
        applicable_months: [],
      });
      setSalaryRangeEntries([["", ""]]);
    }
  }, [show, initialData]);

  const handleAddSalaryRange = () => {
    setSalaryRangeEntries([...salaryRangeEntries, ["", ""]]);
  };

  const handleRemoveSalaryRange = (index) => {
    const updated = [...salaryRangeEntries];
    updated.splice(index, 1);
    setSalaryRangeEntries(updated);
  };

  const handleSalaryRangeChange = (index, type, value) => {
    const updated = [...salaryRangeEntries];
    updated[index][type === "key" ? 0 : 1] = value;
    setSalaryRangeEntries(updated);
  };

  const handleSubmit = (values, { resetForm }) => {
    const salary_range_amount = Object.fromEntries(salaryRangeEntries);
    const finalValues = {
      ...values,
      salary_range_amount,
    };

    const action = isEdit
      ? updateChallan(initialData.id, finalValues)
      : addChallanMaster(finalValues);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting challan form:", error);
      });
  };

  const monthOptions = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {isEdit ? "Edit Challan" : "Add Challan"}
       
      </DialogTitle>

      <DialogContent dividers style={{ maxHeight: "600px", overflowY: "auto" }}>
        <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
          {({ values, setFieldValue, handleChange }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Challan Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  options={challanTypeOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    challanTypeOptions.find(
                      (opt) => opt.value === values.challan_type
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setFieldValue("challan_type", newValue ? newValue.value : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Challan Type"
                      name="challan_type" 
                    />
                  )}
                 
                />
              </Grid>


                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Amount (₹)"
                    name="amount"
                    type="number"
                    value={values.amount}
                    onChange={handleChange}
                    disabled={["percentage", "salary_range"].includes(values.challan_type)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Percentage (%)"
                    name="percentage"
                    type="number"
                    value={values.percentage}
                    onChange={handleChange}
                    disabled={["fixed", "salary_range"].includes(values.challan_type)}
                  />
                </Grid>

               {values.challan_type === "salary_range" && (
                  <Grid item xs={12}  >
                    <Typography variant="subtitle1" gutterBottom>
                      Salary Range Amounts
                      <IconButton size="small" onClick={handleAddSalaryRange}>
                        <FaPlus color="#0d6efd" />
                      </IconButton>
                    </Typography>

                    {salaryRangeEntries.map(([key, value], index) => (
                      <Grid item xs={12} key={index} sx={{ mt: 2 }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <TextField
                            fullWidth
                            placeholder="Range (e.g. 0-10000)"
                            value={key}
                            onChange={(e) =>
                              handleSalaryRangeChange(index, "key", e.target.value)
                            }
                          />
                          <TextField
                            fullWidth
                            type="number"
                            placeholder="Amount"
                            value={value}
                            onChange={(e) =>
                              handleSalaryRangeChange(index, "value", e.target.value)
                            }
                          />
                          <IconButton onClick={() => handleRemoveSalaryRange(index)}>
                            <FaTrash color="red" />
                          </IconButton>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                )}
                <Grid item xs={12}>
  <Typography variant="subtitle1" gutterBottom>
    Employee Contribution
  </Typography>
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    select
    fullWidth
    label="Type"
    name="employee_contribution.type"
    value={values.employee_contribution?.type || ""}
    onChange={handleChange}
  >
    {contributionTypeOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    fullWidth
    label="Value"
    name="employee_contribution.value"
    type="number"
    value={values.employee_contribution?.value || ""}
    onChange={handleChange}
  />
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    fullWidth
    label="Salary Cap (Optional)"
    name="employee_contribution.salary_cap"
    type="number"
    value={values.employee_contribution?.salary_cap || ""}
    onChange={handleChange}
  />
</Grid>

{/* Employer Contribution Section */}
<Grid item xs={12}>
  <Typography variant="subtitle1" gutterBottom>
    Employer Contribution
  </Typography>
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    select
    fullWidth
    label="Type"
    name="employer_contribution.type"
    value={values.employer_contribution?.type || ""}
    onChange={handleChange}
    helperText="This field for only ESI and PF contribution"
  >
    {contributionTypeOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    fullWidth
    label="Value"
    name="employer_contribution.value"
    type="number"
    value={values.employer_contribution?.value || ""}
    onChange={handleChange}
    helperText="This field for only ESI and PF contribution add PF Pension Scheme percentage only"
  />
</Grid>
<Grid item xs={12} md={4}>
  <TextField
    fullWidth
    label="Salary Cap (Optional)"
    name="employer_contribution.salary_cap"
    type="number"
    value={values.employer_contribution?.salary_cap || ""}
    onChange={handleChange}
  />
</Grid>

                <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                <Autocomplete
                  fullWidth
                  options={applicabilityOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    applicabilityOptions.find(
                      (opt) => opt.value === values.applicability
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setFieldValue("applicability", newValue ? newValue.value : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Applicability"
                      name="applicability"
                     
                    />
                  )}
                 
                />
              </Grid>


              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Applicable Salary Component"
                  name="applicable_salary_component"
                  value={values.applicable_salary_component}
                  onChange={handleChange}
                  placeholder="e.g. basic_salary or gross_salary"
                  helperText="e.g. Basic Salary or Gross Salary"
                />
              </Grid>


                {["quarterly", "half_yearly", "annually"].includes(values.applicability) && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      Select Applicable Months
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={1} mb={1}>
                      {monthOptions.map((month) => {
                        const isSelected = values.applicable_months.includes(month);
                        return (
                          <Box
                            key={month}
                            onClick={() => {
                              const updated = isSelected
                                ? values.applicable_months.filter((m) => m !== month)
                                : [...values.applicable_months, month];
                              setFieldValue("applicable_months", updated);
                            }}
                            sx={{
                              px: 2,
                              py: 1,
                              border: `1px solid ${isSelected ? "#0d6efd" : "#ccc"}`,
                              borderRadius: "6px",
                              backgroundColor: isSelected ? "#0d6efd" : "#f8f9fa",
                              color: isSelected ? "#fff" : "#000",
                              cursor: "pointer",
                              fontWeight: 500,
                            }}
                          >
                            {month}
                          </Box>
                        );
                      })}
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Typography>Description</Typography>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      overflowY: "auto",
                      maxHeight: 200,
                    }}
                  >
                    <Editor
                      value={values.description}
                      onChange={(e) => setFieldValue("description", e.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} textAlign="right">
                  <Button
                    variant="outlined"
                   
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    {isEdit ? "Update" : "Submit"}
                  </Button>

                  {isLoding && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100vh",
                        width: "100vw",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "rgba(255, 255, 255, 0.6)",
                        zIndex: 9999,
                      }}
                    >
                      <div
                        style={{
                          background: "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        <FadeLoader
                          // color={"#f27121"} // fallback color, not used with gradient
                          loading={true}
                          size={150}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    </div>
                  )}
                </Grid>

              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}

export default ChallanFormModal;


































// import React, { useEffect, useState } from "react";
// import "../../styles/styles.css";
// import "../../styles/layout.css";
// import { Modal, Row, Col } from "react-bootstrap";
// import { Formik, Form, Field } from "formik";
// import MasterViewController from "../../redux/actions/masterApiActions";
// import { useDispatch, useSelector } from "react-redux";
// import Editor from "react-simple-wysiwyg";
// import { FaPlus, FaTrash } from "react-icons/fa";

// function ChallanFormModal({ show, handleClose, initialData = null }) {
//   const dispatch = useDispatch();
//   const { addChallanMaster, updateChallan } = MasterViewController();
//   const { challans } = useSelector((state) => state.master);
//   const isEdit = Boolean(initialData?.id);

//   const [initialValues, setInitialValues] = useState({
//     name: "",
//     amount: "",
//     percentage: "",
//     description: "",
//     salary_range_amount: {},
//     challan_type: "percentage",
//     applicability: "monthly",
//     applicable_salary_component: "",
//   });

//   const [salaryRangeEntries, setSalaryRangeEntries] = useState([]);

//   useEffect(() => {
//     if (show && initialData) {
//       setInitialValues({
//         name: initialData.name || "",
//         amount: initialData.amount || "",
//         percentage: initialData.percentage || "",
//         description: initialData.description || "",
//         salary_range_amount: initialData.salary_range_amount || {},
//         challan_type: initialData.challan_type || "percentage",
//         applicability: initialData.applicability || "monthly",
//         applicable_salary_component: initialData.applicable_salary_component || "",
//       });

//       const entries = Object.entries(initialData.salary_range_amount || {});
//       setSalaryRangeEntries(entries);
//     } else if (show && !initialData) {
//       setInitialValues({
//         name: "",
//         amount: "",
//         percentage: "",
//         description: "",
//         salary_range_amount: {},
//         challan_type: "percentage",
//         applicability: "monthly",
//         applicable_salary_component: "",
//       });
//       setSalaryRangeEntries([]);
//     }
//   }, [show, initialData]);

//   const handleAddSalaryRange = () => {
//     setSalaryRangeEntries([...salaryRangeEntries, ["", ""]]);
//   };

//   const handleRemoveSalaryRange = (index) => {
//     const updated = [...salaryRangeEntries];
//     updated.splice(index, 1);
//     setSalaryRangeEntries(updated);
//   };

//   const handleSalaryRangeChange = (index, type, value) => {
//     const updated = [...salaryRangeEntries];
//     updated[index][type === "key" ? 0 : 1] = value;
//     setSalaryRangeEntries(updated);
//   };

//   const handleSubmit = (values, { resetForm }) => {
//     const salary_range_amount = Object.fromEntries(salaryRangeEntries);
//     const finalValues = {
//       ...values,
//       salary_range_amount,
//     };

//     const action = isEdit
//       ? updateChallan(initialData.id, finalValues)
//       : addChallanMaster(finalValues);

//     dispatch(action)
//       .then(() => {
//         resetForm();
//         handleClose();
//       })
//       .catch((error) => {
//         console.error("Error submitting challan form:", error);
//       });
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title className="d-flex align-items-center">
//           {isEdit ? "Edit Challan" : "Add Challan"}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Formik
//           initialValues={initialValues}
//           onSubmit={handleSubmit}
//           enableReinitialize
//         >
//           {({ values, setFieldValue }) => (
//             <Form>
//               <Row>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Challan Name</label>
//                     <Field name="name" className="form-control" />
//                   </div>
//                 </Col>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Challan Type</label>
//                     <Field as="select" name="challan_type" className="form-control">
//                       <option value="percentage">Percentage</option>
//                       <option value="fixed">Fixed Amount</option>
//                       <option value="salary_range">Salary Range Based</option>
//                       <option value="custom">Custom Logic</option>
//                     </Field>
//                   </div>
//                 </Col>
//               </Row>

//               <Row>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Amount (₹)</label>
//                     <Field name="amount" type="number" className="form-control" />
//                   </div>
//                 </Col>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Percentage (%)</label>
//                     <Field name="percentage" type="number" className="form-control" />
//                   </div>
//                 </Col>
//               </Row>

//               <div className="mb-2">
//                  <div className="d-flex align-items-center mb-1">
//                    <label className="form-label mb-0 me-2">
//                      Salary Range Amounts
//                    </label>
//                    <FaPlus
//                      style={{ cursor: "pointer", color: "#0d6efd" }}
//                      onClick={handleAddSalaryRange}
//                    />
//                 </div>
//                  <Row className="g-2 align-items-center">
//                    {salaryRangeEntries.map(([key, value], index) => (
//                      <React.Fragment key={index}>
//                        <Col xs={5}>
//                          <input
//                            type="text"
//                            className="form-control"
//                            placeholder="Range (e.g. 0-10000)"
//                            value={key}
//                            onChange={(e) =>
//                              handleSalaryRangeChange(
//                                index,
//                                "key",
//                                e.target.value
//                              )
//                            }
//                          />
//                        </Col>
//                        <Col xs={5}>
//                          <input
//                            type="number"
//                            className="form-control"
//                            placeholder="Amount"
//                            value={value}
//                            onChange={(e) =>
//                              handleSalaryRangeChange(
//                                index,
//                                "value",
//                                e.target.value
//                              )
//                            }
//                          />
//                        </Col>
//                        <Col xs={2} className="text-end">
//                          <FaTrash
//                            style={{ cursor: "pointer", color: "red" }}
//                            onClick={() => handleRemoveSalaryRange(index)}
//                          />
//                        </Col>
//                      </React.Fragment>
//                    ))}
//                  </Row>
//                </div>

//               <Row>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Applicability</label>
//                     <Field as="select" name="applicability" className="form-control">
//                       <option value="monthly">Monthly</option>
//                       <option value="quarterly">Quarterly</option>
//                       <option value="half_yearly">Half-Yearly</option>
//                       <option value="annually">Annually</option>
//                       <option value="on_demand">On Demand</option>
//                     </Field>
//                   </div>
//                 </Col>
//                 <Col>
//                   <div className="mb-2">
//                     <label>Applicable Salary Component</label>
//                     <Field
//                       name="applicable_salary_component"
//                       className="form-control"
//                       placeholder="e.g., basic_salary"
//                     />
//                   </div>
//                 </Col>
//               </Row>

//               <div className="mb-2">
//                 <label>Description</label>
//                 <div
//                   style={{
//                     maxHeight: "200px",
//                     overflowY: "auto",
//                     border: "1px solid #ced4da",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <Editor
//                     value={values.description}
//                     onChange={(e) =>
//                       setFieldValue("description", e.target.value)
//                     }
//                   />
//                 </div>
//               </div>

//               <div className="mt-3 text-end">
//                 <button type="submit" className="btn btn-primary">
//                   {isEdit ? "Update" : "Submit"}
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default ChallanFormModal;





















